import React from 'react'
import { useTranslation } from 'react-i18next'
import { DeliveryType } from '../../../Data/DeliveryTypeEnum.ts';
import '../OrderIndex.css'

const DeliveryCard = ({ order }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className='row justify-content-center'>
        <div className='justify-content-center mt-2'>
          <div>
            <div className='panel-header-title'>{t('delivery')}</div>
            <div className="order-checkbox-option">
              <div className="option">
                <input className='checkbox-custom' type='checkbox' checked={true} />
                <label>{order.delivery}</label>
                {/* <label style={{ fontWeight: "bold" }}>tutaj cena dostawy </label> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeliveryCard